module.exports = __webpack_public_path__ + "media/images/faramia/linkedin-849e49e0b4507f20b191f341a8b244de.png";